<div class="section-block">
  <!-- Title -->
  <div class="section-header" (click)="COLLAPSE_ACCESS = !COLLAPSE_ACCESS"
    [attr.aria-expanded]="!COLLAPSE_ACCESS" aria-controls="collapseEvent">
    <i [class]="COLLAPSE_ACCESS ? 'fa fa-minus' : 'fa fa-plus'"></i>
    <div class="text">Link Access</div>
  </div>

  <!-- Forgiveness Access Collapsed Data -->
  <div class="access" [collapse]="!COLLAPSE_ACCESS">
    <!-- Not Accessed message -->
    <ng-container *ngIf="!report?.LINK_ACCESS || report?.LINK_ACCESS.length <= 0">
      <div class="text-center">User has not accessed this link.</div>
    </ng-container>

    <!-- Access List -->
    <ng-container *ngFor="let access of report?.LINK_ACCESS">
      <div class="access-value">
        <!-- Link -->
        <div class="row" *ngIf="access.LINK">
          <div class="col-4">
            <div class="label">Link:</div>
          </div>
          <div class="col-8">
            <div class="small value">
              {{access.LINK}}
            </div>
          </div>
        </div>

        <!-- Browser -->
        <div class="row" *ngIf="access.BROWSER">
          <div class="col-4">
            <div class="label">Browser:</div>
          </div>
          <div class="col-8 ellipsis date value">
            {{access.BROWSER}}
          </div>
        </div>

        <!-- Ip Address -->
        <div class="row" *ngIf="access.IP_ADDRESS">
          <div class="col-4">
            <div class="label">IP:</div>
          </div>
          <div class="col-8">
            <div class="date value">
              {{access.IP_ADDRESS}}
            </div>
          </div>
        </div>

        <!-- Accessed Date -->
        <div class="row">
          <div class="col-4">
            <div class="label">Accessed on:</div>
          </div>
          <div class="col-8">
            <div class="date value">
              {{access.ACCESSED_DATE | date: 'MM/dd/yy hh:mm:ss a'}}
            </div>
          </div>
        </div>

        <!-- City -->
        <div class="row" *ngIf="access.CITY">
          <div class="col-4">
            <div class="label">City:</div>
          </div>
          <div class="col-8">
            <div class="date value">
              {{access.CITY}}
            </div>
          </div>
        </div>

        <div class="row" *ngIf="access.COUNTRY">
          <div class="col-4">
            <div class="label">Country:</div>
          </div>
          <div class="col-8">
            <div class="date value">
              {{access.COUNTRY}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
